import { useState, type FormEvent } from "react";
import { api, ApiHatasi, sayi, tarih } from "../api";
import { Bildirim, Durum, HataKutusu, Kart, Rozet, Tablo, useCek } from "../ui";
import { Simge } from "../simgeler";
import { Doluluk, Isik } from "../grafik";

const ONEM: Record<string, "iyi" | "uyari" | "kotu"> = {
  bilgi: "iyi",
  uyari: "uyari",
  kritik: "kotu",
};

const TUR_ADI: Record<string, string> = {
  asiri_gonderim: "Aşırı gönderim",
  gunluk_alici_asimi: "Günlük alıcı aşımı",
  gunluk_ileti_asimi: "Günlük posta aşımı",
  tek_postada_cok_alici: "Tek postada çok alıcı",
  cok_farkli_alan: "Çok farklı alan adı",
  basarisiz_giris: "Başarısız giriş",
  ani_artis: "Ani artış",
};

const ESIK_ADI: Record<string, { ad: string; aciklama: string; birim: string }> = {
  gunlukAlici: {
    ad: "Günlük alıcı uyarısı",
    aciklama: "Bir kutu bir günde bu kadar alıcıya yazarsa uyarı üretilir.",
    birim: "alıcı",
  },
  gunlukIleti: {
    ad: "Günlük posta uyarısı",
    aciklama: "Bir kutu bir günde bu kadar posta gönderirse uyarı üretilir.",
    birim: "posta",
  },
  tekPostaAlici: {
    ad: "Tek postada alıcı",
    aciklama: "Tek bir postada bu kadar alıcı olması toplu gönderim belirtisidir.",
    birim: "alıcı",
  },
  farkliAlan: {
    ad: "Farklı alan adı",
    aciklama: "Bir günde bu kadar farklı alan adına yazmak dağıtım listesi belirtisidir.",
    birim: "alan",
  },
  basarisizGiris: {
    ad: "Başarısız giriş",
    aciklama: "Bir kutuya bu kadar hatalı parola denemesi parola saldırısı olabilir.",
    birim: "deneme",
  },
  otomatikKilitAlici: {
    ad: "Otomatik kilit sınırı",
    aciklama:
      "Bu sınır aşılırsa beklenmez: kutu ANINDA kilitlenir. Ele geçirilmiş bir kutunun " +
      "sunucunun itibarını yakmasını engeller.",
    birim: "alıcı",
  },
};

/**
 * TELEGRAM ETKİNLEŞTİRME
 *
 * Önceden bu kutu "sunucuda şu dosyaya şunu yazın" diyordu. Doğruydu ama
 * işletmecinin elinde SSH anahtarı ve terminal olmasını gerektiriyordu —
 * telefondan ya da başka bir bilgisayardan yapılamıyordu.
 *
 * Jeton yine dışarıdan gelir (@BotFather onu yalnızca botu kuran kişiye
 * verir) ama artık bir forma yapıştırmak yeterli. Jeton BİR DAHA
 * GÖSTERİLMEZ: hiçbir uç onu geri döndürmüyor.
 */
function TelegramKurulum({ bitti }: { bitti: () => void }) {
  const [jeton, setJeton] = useState("");
  const [bekliyor, setBekliyor] = useState(false);
  const [hata, setHata] = useState<string | null>(null);
  const [ipucu, setIpucu] = useState<string | null>(null);

  async function gonder(e: FormEvent) {
    e.preventDefault();
    setHata(null);
    setIpucu(null);
    setBekliyor(true);
    try {
      const y = await api.telegramKur(jeton.trim());
      // Jeton bellekte tutulmaz
      setJeton("");
      bitti();
      window.alert(
        `Bot etkinleştirildi: @${y.veri.botAdi}\n\n` +
          `Sohbet: ${y.veri.sohbetAdi || y.veri.sohbet} (${y.veri.sohbetTuru})\n\n` +
          `Telegram'da /yardim yazarak başlayabilirsiniz. Bot yapılandırmayı ` +
          `bir dakika içinde kendiliğinden yakalar.`,
      );
    } catch (h) {
      if (h instanceof ApiHatasi) {
        setHata(h.message);
        // Sunucu "ne yapmali" ipucunu ayrinti alaninda gonderiyor
        if (typeof h.ayrinti === "string") setIpucu(h.ayrinti);
      } else {
        setHata("Etkinleştirilemedi");
      }
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <Kart baslik="Telegram bildirimini açın">
      <p style={{ marginTop: 0 }}>
        Kritik bir olayda e-posta ile haber vermek güvenilir değildir —
        bildirilecek şey posta sisteminin kendisi olabilir. Telegram ikinci bir
        kanaldır ve komut da verebilirsiniz.
      </p>
      <ol style={{ paddingLeft: 20, marginTop: 0 }}>
        <li>
          Telegram'da <code>@BotFather</code> ile konuşun, <code>/newbot</code> yazın
        </li>
        <li>Yeni botunuzu açıp ona bir mesaj yazın — "merhaba" yeterli</li>
        <li>Size verilen jetonu aşağıya yapıştırın</li>
      </ol>

      <form onSubmit={gonder}>
        <label>
          BotFather jetonu
          <input
            type="password"
            value={jeton}
            onChange={(e) => setJeton(e.target.value)}
            placeholder="123456789:AA…"
            autoComplete="off"
            spellCheck={false}
            required
          />
        </label>

        {hata && (
          <Bildirim tur="kotu">
            <strong>{hata}</strong>
            {ipucu ? <div style={{ marginTop: 6 }}>{ipucu}</div> : null}
          </Bildirim>
        )}

        <button type="submit" className="dugme ana" disabled={bekliyor || !jeton.trim()}>
          {bekliyor ? "Doğrulanıyor…" : "Etkinleştir"}
        </button>
      </form>

      <p className="soluk" style={{ fontSize: 13, marginBottom: 0 }}>
        Jeton doğrulanmadan hiçbir şey kaydedilmez. Sohbet kimliğini panel
        kendisi bulur; jeton bir daha gösterilmez.
      </p>
    </Kart>
  );
}

export function Guvenlik() {
  const g = useCek(() => api.guvenlik(), []);
  const [hata, setHata] = useState<ApiHatasi | null>(null);
  const [bilgi, setBilgi] = useState<string | null>(null);
  const [bekliyor, setBekliyor] = useState<string | null>(null);
  const [duzenle, setDuzenle] = useState<Record<string, string>>({});

  async function calistir(ad: string, f: () => Promise<string>) {
    setHata(null);
    setBilgi(null);
    setBekliyor(ad);
    try {
      setBilgi(await f());
      g.yenile();
    } catch (h) {
      setHata(h instanceof ApiHatasi ? h : new ApiHatasi(String(h), "bilinmiyor", 0));
    } finally {
      setBekliyor(null);
    }
  }

  return (
    <>
      <div className="baslik">
        <div>
          <h1>Güvenlik</h1>
          <p>
            Normal bir kullanıcı günde birkaç posta gönderir. Bunun belirgin üstü ya bir hata ya da
            ele geçirilmiş bir hesaptır. Sistem her 5 dakikada bir kontrol eder; ağır durumlarda
            kutuyu <strong>kendiliğinden kilitler</strong>.
          </p>
        </div>
        <div className="eylemler">
          <button
            className="dugme"
            disabled={bekliyor !== null}
            onClick={() =>
              calistir("tara", async () => {
                const y = await api.guvenlikTara();
                return (
                  `${y.veri.incelenen} kutu incelendi. ${y.veri.olay} yeni olay, ` +
                  `${y.veri.kilitlenen} kutu kilitlendi, ${y.veri.bildirilen} bildirim gönderildi.`
                );
              })
            }
          >
            {bekliyor === "tara" ? "Taranıyor…" : "Şimdi tara"}
          </button>
        </div>
      </div>

      {hata && <HataKutusu hata={hata} />}
      {bilgi && <Bildirim tur="iyi">{bilgi}</Bildirim>}

      <Durum cekim={g}>
        {(d) => (
          <>
            {/* --- bildirim kanali --- */}
            {d.operator === false ? null : d.bildirim?.telegram ? (
              <Bildirim tur="iyi">
                <strong>Telegram bildirimi açık</strong> — "{d.bildirim.asgari}" ve üstü olaylar
                anında iletiliyor.{" "}
                <button
                  className="dugme kucuk"
                  style={{ marginLeft: 8 }}
                  disabled={bekliyor !== null}
                  onClick={() =>
                    calistir("dene", async () => {
                      const y = await api.bildirimDene();
                      return y.gonderildi
                        ? "Deneme iletisi gönderildi. Telegram'ı kontrol edin."
                        : "Gönderilemedi. Jeton ve sohbet kimliğini kontrol edin.";
                    })
                  }
                >
                  deneme gönder
                </button>
              </Bildirim>
            ) : (
              <TelegramKurulum bitti={() => g.yenile()} />
            )}

            {/* --- olaylar --- */}
            <DmarcKarti />

            <Kart baslik={`Güvenlik olayları (${d.olaylar.length})`}>
              {d.olaylar.length === 0 ? (
                <div className="bos">
                  Kayıtlı olay yok. Bu iyi haber: hiçbir kutu olağandışı davranmıyor.
                </div>
              ) : (
                <Tablo basliklar={["Önem", "Olay", "Kutu", "Açıklama", "İşlem", "Zaman"]}>
                  {d.olaylar.map((o) => (
                    <tr key={o.id}>
                      <td>
                        <Rozet tur={ONEM[o.agirlik]}>{o.agirlik}</Rozet>
                      </td>
                      <td>{TUR_ADI[o.tur] ?? o.tur}</td>
                      <td className="tek">{o.eposta ?? "—"}</td>
                      <td style={{ color: "var(--n-600)", maxWidth: 380 }}>{o.aciklama}</td>
                      <td>
                        {o.islem ? <Rozet tur="uyari">{o.islem}</Rozet> : <span style={{ color: "var(--n-500)" }}>—</span>}
                      </td>
                      <td style={{ whiteSpace: "nowrap" }}>{tarih(o.zaman)}</td>
                    </tr>
                  ))}
                </Tablo>
              )}
            </Kart>

            <div style={{ height: 16 }} />

            {/* --- bugunku gonderim --- */}
            <Kart baslik="Bugünkü gönderim (kutu bazında)">
              {d.bugun.length === 0 ? (
                <div className="bos">Bugün gönderim yok</div>
              ) : (
                <Tablo
                  basliklar={["Kutu", "#Posta", "#Alıcı", "#Tek postada en çok", "#Farklı alan", "#Hatalı giriş"]}
                >
                  {d.bugun
                    .filter((s) => s.giden_alici > 0 || s.basarisiz_giris > 0)
                    .map((s) => {
                      const yuksek = s.giden_alici > (d.esikler.gunlukAlici ?? 50);
                      return (
                        <tr key={s.eposta}>
                          <td className="tek">{s.eposta}</td>
                          <td className="sayi">{sayi(s.giden_ileti)}</td>
                          <td className="sayi" style={yuksek ? { color: "var(--bad)", fontWeight: 700 } : undefined}>
                            {sayi(s.giden_alici)}
                          </td>
                          <td className="sayi">{s.en_cok_alici}</td>
                          <td className="sayi">{s.farkli_alan}</td>
                          <td className="sayi" style={s.basarisiz_giris > 0 ? { color: "var(--warn)" } : undefined}>
                            {s.basarisiz_giris}
                          </td>
                        </tr>
                      );
                    })}
                </Tablo>
              )}
            </Kart>

            <div style={{ height: 16 }} />

            {/* --- esikler: yalnizca operator --- */}
            {d.operator !== false && (
            <Kart baslik="Uyarı eşikleri">
              <div className="ic">
                <p style={{ color: "var(--n-600)", marginTop: 0, fontSize: 13 }}>
                  Kurumunuzda normal kullanım günde birkaç posta ise bu değerleri düşürün; toplu
                  duyuru gönderen müşteriniz varsa yükseltin. Değişiklik anında geçerli olur.
                </p>
                <Tablo basliklar={["Eşik", "Değer", ""]}>
                  {Object.entries(d.esikler).map(([k, v]) => {
                    const bilgi = ESIK_ADI[k];
                    return (
                      <tr key={k}>
                        <td>
                          <strong>{bilgi?.ad ?? k}</strong>
                          <div style={{ color: "var(--n-500)", fontSize: 12, maxWidth: 460 }}>
                            {bilgi?.aciklama ?? ""}
                          </div>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <input
                            className="kucuk-girdi"
                            type="number"
                            min={1}
                            style={{ width: 92 }}
                            value={duzenle[k] ?? String(v)}
                            onChange={(e) => setDuzenle({ ...duzenle, [k]: e.target.value })}
                          />
                          <span style={{ color: "var(--n-500)", fontSize: 12, marginLeft: 6 }}>
                            {bilgi?.birim ?? ""}
                          </span>
                        </td>
                        <td>
                          {duzenle[k] !== undefined && duzenle[k] !== String(v) && (
                            <button
                              className="dugme kucuk ana"
                              disabled={bekliyor !== null}
                              onClick={() =>
                                calistir("esik", async () => {
                                  await api.guvenlikEsikler({ [k]: Number(duzenle[k]) });
                                  setDuzenle({});
                                  return `${bilgi?.ad ?? k} güncellendi.`;
                                })
                              }
                            >
                              kaydet
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </Tablo>
              </div>
            </Kart>
            )}
          </>
        )}
      </Durum>
    </>
  );
}

/**
 * DMARC toplu raporlari — "adiniza kim posta gonderdi".
 *
 * Bu tablo tek bir soruya cevap verir: son bir haftada sizin alan adinizdan
 * gonderilmis gibi gorunen postalarin kaynagi neresi? Bizim sunucumuz disinda
 * bir kaynak varsa ya unutulmus bir gonderici (eski saglayici, web formu,
 * muhasebe yazilimi) ya da adinizi kullanan biri vardir.
 *
 * Gosterilen veri SAYIMDIR; toplu raporlar posta icerigi tasimaz.
 */
function DmarcKarti() {
  const [gun, setGun] = useState(7);
  const [bekliyor, setBekliyor] = useState(false);
  const d = useCek(() => api.dmarc(gun), [gun]);

  async function cek() {
    setBekliyor(true);
    try {
      await api.dmarcCek();
      d.yenile();
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <Kart
      baslik="Adınıza kim posta gönderdi?"
      eylem={
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <select value={gun} onChange={(e) => setGun(Number(e.target.value))} style={{ fontSize: 13 }}>
            <option value={7}>7 gün</option>
            <option value={30}>30 gün</option>
            <option value={90}>90 gün</option>
          </select>
          <button className="dugme kucuk" onClick={cek} disabled={bekliyor}>
            {bekliyor ? "çekiliyor…" : "şimdi çek"}
          </button>
        </div>
      }
    >
      <Durum cekim={d}>
        {(y) =>
          y.veri.alanlar.length === 0 ? (
            <div className="ic">
              <Bildirim>
                Henüz DMARC raporu gelmedi. Raporlar alıcı sunucular tarafından günlük gönderilir;
                DMARC kaydınız yeni ayarlandıysa ilk raporun gelmesi bir günü bulur.
              </Bildirim>
            </div>
          ) : (
            <div className="ic">
              {y.veri.alanlar.map((o) => (
                <div key={o.alan} style={{ marginBottom: 22 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      justifyContent: "space-between",
                      gap: 12,
                      flexWrap: "wrap",
                      marginBottom: 8,
                    }}
                  >
                    <strong style={{ fontSize: 14.5 }}>{o.alan}</strong>
                    <span style={{ fontSize: 12.5, color: "var(--n-500)" }}>
                      {sayi(o.toplamIleti)} ileti · {o.kaynaklar.length} kaynak
                      {o.saglayicilar.length ? ` · rapor: ${o.saglayicilar.slice(0, 3).join(", ")}` : ""}
                    </span>
                  </div>

                  <Doluluk
                    oran={o.oran}
                    etiket="Kimlik doğrulaması geçen"
                    deger={`${sayi(o.gecen)} / ${sayi(o.toplamIleti)}`}
                    esik={0}
                  />

                  <div style={{ height: 10 }} />

                  <Tablo basliklar={["", "Kaynak", "#İleti", "#Doğrulanmadı", "Kimlik"]}>
                    {o.kaynaklar.map((k) => (
                      <tr key={k.ip}>
                        <td style={{ width: 28 }}>
                          <Isik durum={k.bizimMi ? "iyi" : k.kalan ? "kotu" : "uyari"} />
                        </td>
                        <td className="tek">{k.ip}</td>
                        <td className="sayi">{sayi(k.ileti)}</td>
                        <td className="sayi" style={k.kalan ? { color: "var(--bad)", fontWeight: 600 } : undefined}>
                          {k.kalan ? sayi(k.kalan) : "—"}
                        </td>
                        <td>
                          {k.bizimMi ? (
                            <Rozet tur="iyi">bizim sunucumuz</Rozet>
                          ) : k.spfAlan || k.dkimAlan ? (
                            <span className="tek">{k.spfAlan || k.dkimAlan}</span>
                          ) : (
                            <Rozet tur="kotu">tanımıyoruz</Rozet>
                          )}
                        </td>
                      </tr>
                    ))}
                  </Tablo>

                  {o.supheli.length > 0 && (
                    <Bildirim tur="uyari">
                      <strong>{o.supheli.length} kaynak</strong> bizim sunucumuz değil ve kimlik
                      doğrulaması tutmadı. Ya unutulmuş bir gönderici (eski sağlayıcı, web formu,
                      muhasebe yazılımı) ya da adınızı kullanan biri. DMARC politikasını
                      sıkılaştırmadan önce bu listenin temiz olması gerekir.
                    </Bildirim>
                  )}
                </div>
              ))}
            </div>
          )
        }
      </Durum>
    </Kart>
  );
}
